// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.mydatahelps-app {
	background: var(--mdh-background-color-1);
	color: var(--mdh-text-color-1);
}

.mydatahelps {
	max-width: 1024px;
	margin: 0 auto;
}

@media (min-width: 1024px) {
	.mydatahelps {
		box-shadow: 0px 0px 3px #aaa;
	}
}

.mydatahelps .loading-indicator {
	text-align: center;
	padding: 20px;
	color: var(--mdh-text-color-4);
}

.mydatahelps .page-wrapper {
	position: relative;
	box-sizing: border-box;
	-webkit-tap-highlight-color: transparent;
}

.mydatahelps .page-content {
	background: var(--mdh-background-color-0);
	-webkit-tap-highlight-color: transparent;
	overflow: hidden;
	overflow-y: auto;
}

.mydatahelps .page-content .page-title {
	font-size: 36px;
	font-weight: bold;
	padding: 16px;
	padding-top: 41px;
	line-height: 36px;
}

@media (max-width: 680px) {
	body {
		background: var(--mdh-background-color-0);
	}

	.mydatahelps .page-content {
		min-height: 100%;
		box-sizing: border-box;
		height: calc(100dvh - 98px);
	}

	.mydatahelps .page-wrapper.full-width .page-content {
		height: calc(100dvh - 48px);
	}
}

@media (min-width: 680px) {
	.mydatahelps .page-wrapper {
		padding-left: 220px;
	}

	.mydatahelps .page-wrapper.full-width {
		padding-left: 0;
	}

	.mydatahelps .page-content {
		border-left: solid 1px var(--mdh-border-color-1);
		height: calc(100vh - 48px);
	}

	.mydatahelps .page-wrapper.full-width .page-content {
		border: none;
	}
}

.mydatahelps .page-content.hidden-content {
	height: 0px;
	min-height: 0;
	overflow: hidden;
}

.mydatahelps .primary-btn,
.mydatahelps .secondary-btn {
	height: 44px;
	border-radius: 5px;
	text-align: center;
	line-height: 44px;
	font-size: 15px;
	font-weight: bold;
	cursor: pointer;
	border: none;
}

.mydatahelps .primary-btn {
	color: #FFF;
	background: #366DBC;
}

.mydatahelps .secondary-btn {
	background: #FFF;
	color: #366DBC;
}

.mydatahelps .secondary-btn .fa {
	font-size: 21px;
}

.mydatahelps .mdh-alert {
	position: fixed;
	width: 100%;
	left: 0;
	top: 0;
	z-index: 2;
}

.mydatahelps .mdh-alert .mdh-alert-window {
	background: #FFF;
	border-radius: 5px;
	text-align: center;
	z-index: 6001;
	width: 325px;
	margin: 0px auto;
	margin-top: 90px;
	position: relative;
}

.mydatahelps .mdh-alert .mdh-alert-content {
	padding: 20px;
}

.mydatahelps .mdh-alert .mdh-alert-title {
	font-size: 17px;
	font-weight: bold;
	margin-bottom: 10px;
}

.mydatahelps .mdh-alert .mdh-alert-message {
	font-size: 12px;
	line-height: 16px;
}

.mydatahelps .mdh-alert .mdh-alert-buttons {
	border-top: solid 1px #ddd;
}

.mydatahelps .mdh-alert .mdh-alert-button {
	padding: 15px;
	color: #0067B1;
	display: inline-block;
	background: #FFF;
	outline: none !important;
	font-size: 16px;
	cursor: pointer;
	font-weight: bold;
}

.mydatahelps .mdh-alert .mdh-alert-overlay {
	position: fixed !important;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background: #000;
	opacity: .25;
	z-index: 6000 !important;
}

.mydatahelps .bad-browser {
	font-size: 1.5em;
	color: black;
	border: 1px solid red;
	background-color: #ffeeee;
	height: 100px;
	position: fixed;
	left: 0;
	bottom: 56px;
	width: 100%;
	z-index: 2000;
	display: flex;
	justify-content: center;
	padding-top: 15px;
}

.mydatahelps .bad-browser .fa {
	color: red;
}

.mydatahelps .footer {
	display: none;
	position: fixed;
	left: 0;
	bottom: 0;
	width: 100%;
	background: #FFF;
	padding: 8px 16px;
	height: 56px;
	box-sizing: border-box;
	text-align: center;
	box-shadow: 0px -1px 2px 0 rgba(0, 0, 0, 0.2);
}

.mydatahelps .footer .app-download {
	display: inline-block;
}

.mydatahelps .footer .app-download .app-download-link {
	float: left;
	margin-left: 8px;
}

.mydatahelps .footer .app-download .app-download-link img {
	height: 40px;
}

.mydatahelps .footer .footer-text {
	float: left;
	line-height: 40px;
	font-size: 15px;
	color: #0C509B;
	font-weight: bold;
}

@media (min-width: 680px) {
	.mydatahelps .footer {
		display: block;
		z-index: 10;
	}
}

.provider-account-interstitial .mydatahelps-header {
	display: none;
}

@media (min-width: 1024px) {
	.mydatahelps.provider-account-interstitial {
		box-shadow: none;
	}
}
`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/MyDataHelps.css"],"names":[],"mappings":"AAAA;CACC,yCAAyC;CACzC,8BAA8B;AAC/B;;AAEA;CACC,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC;EACC,4BAA4B;CAC7B;AACD;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,wCAAwC;AACzC;;AAEA;CACC,yCAAyC;CACzC,wCAAwC;CACxC,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,aAAa;CACb,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC;EACC,yCAAyC;CAC1C;;CAEA;EACC,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;CAC5B;;CAEA;EACC,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,mBAAmB;CACpB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,gDAAgD;EAChD,0BAA0B;CAC3B;;CAEA;EACC,YAAY;CACb;AACD;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;AACjB;;AAEA;;CAEC,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,YAAY;AACb;;AAEA;CACC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,OAAO;CACP,MAAM;CACN,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,aAAa;CACb,cAAc;CACd,qBAAqB;CACrB,gBAAgB;CAChB,wBAAwB;CACxB,eAAe;CACf,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;CAC1B,MAAM;CACN,QAAQ;CACR,SAAS;CACT,OAAO;CACP,gBAAgB;CAChB,YAAY;CACZ,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,qBAAqB;CACrB,yBAAyB;CACzB,aAAa;CACb,eAAe;CACf,OAAO;CACP,YAAY;CACZ,WAAW;CACX,aAAa;CACb,aAAa;CACb,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,aAAa;CACb,eAAe;CACf,OAAO;CACP,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;CAClB,6CAA6C;AAC9C;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC;EACC,cAAc;EACd,WAAW;CACZ;AACD;;AAEA;CACC,aAAa;AACd;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD","sourcesContent":["body.mydatahelps-app {\n\tbackground: var(--mdh-background-color-1);\n\tcolor: var(--mdh-text-color-1);\n}\n\n.mydatahelps {\n\tmax-width: 1024px;\n\tmargin: 0 auto;\n}\n\n@media (min-width: 1024px) {\n\t.mydatahelps {\n\t\tbox-shadow: 0px 0px 3px #aaa;\n\t}\n}\n\n.mydatahelps .loading-indicator {\n\ttext-align: center;\n\tpadding: 20px;\n\tcolor: var(--mdh-text-color-4);\n}\n\n.mydatahelps .page-wrapper {\n\tposition: relative;\n\tbox-sizing: border-box;\n\t-webkit-tap-highlight-color: transparent;\n}\n\n.mydatahelps .page-content {\n\tbackground: var(--mdh-background-color-0);\n\t-webkit-tap-highlight-color: transparent;\n\toverflow: hidden;\n\toverflow-y: auto;\n}\n\n.mydatahelps .page-content .page-title {\n\tfont-size: 36px;\n\tfont-weight: bold;\n\tpadding: 16px;\n\tpadding-top: 41px;\n\tline-height: 36px;\n}\n\n@media (max-width: 680px) {\n\tbody {\n\t\tbackground: var(--mdh-background-color-0);\n\t}\n\n\t.mydatahelps .page-content {\n\t\tmin-height: 100%;\n\t\tbox-sizing: border-box;\n\t\theight: calc(100dvh - 98px);\n\t}\n\n\t.mydatahelps .page-wrapper.full-width .page-content {\n\t\theight: calc(100dvh - 48px);\n\t}\n}\n\n@media (min-width: 680px) {\n\t.mydatahelps .page-wrapper {\n\t\tpadding-left: 220px;\n\t}\n\n\t.mydatahelps .page-wrapper.full-width {\n\t\tpadding-left: 0;\n\t}\n\n\t.mydatahelps .page-content {\n\t\tborder-left: solid 1px var(--mdh-border-color-1);\n\t\theight: calc(100vh - 48px);\n\t}\n\n\t.mydatahelps .page-wrapper.full-width .page-content {\n\t\tborder: none;\n\t}\n}\n\n.mydatahelps .page-content.hidden-content {\n\theight: 0px;\n\tmin-height: 0;\n\toverflow: hidden;\n}\n\n.mydatahelps .primary-btn,\n.mydatahelps .secondary-btn {\n\theight: 44px;\n\tborder-radius: 5px;\n\ttext-align: center;\n\tline-height: 44px;\n\tfont-size: 15px;\n\tfont-weight: bold;\n\tcursor: pointer;\n\tborder: none;\n}\n\n.mydatahelps .primary-btn {\n\tcolor: #FFF;\n\tbackground: #366DBC;\n}\n\n.mydatahelps .secondary-btn {\n\tbackground: #FFF;\n\tcolor: #366DBC;\n}\n\n.mydatahelps .secondary-btn .fa {\n\tfont-size: 21px;\n}\n\n.mydatahelps .mdh-alert {\n\tposition: fixed;\n\twidth: 100%;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 2;\n}\n\n.mydatahelps .mdh-alert .mdh-alert-window {\n\tbackground: #FFF;\n\tborder-radius: 5px;\n\ttext-align: center;\n\tz-index: 6001;\n\twidth: 325px;\n\tmargin: 0px auto;\n\tmargin-top: 90px;\n\tposition: relative;\n}\n\n.mydatahelps .mdh-alert .mdh-alert-content {\n\tpadding: 20px;\n}\n\n.mydatahelps .mdh-alert .mdh-alert-title {\n\tfont-size: 17px;\n\tfont-weight: bold;\n\tmargin-bottom: 10px;\n}\n\n.mydatahelps .mdh-alert .mdh-alert-message {\n\tfont-size: 12px;\n\tline-height: 16px;\n}\n\n.mydatahelps .mdh-alert .mdh-alert-buttons {\n\tborder-top: solid 1px #ddd;\n}\n\n.mydatahelps .mdh-alert .mdh-alert-button {\n\tpadding: 15px;\n\tcolor: #0067B1;\n\tdisplay: inline-block;\n\tbackground: #FFF;\n\toutline: none !important;\n\tfont-size: 16px;\n\tcursor: pointer;\n\tfont-weight: bold;\n}\n\n.mydatahelps .mdh-alert .mdh-alert-overlay {\n\tposition: fixed !important;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tbackground: #000;\n\topacity: .25;\n\tz-index: 6000 !important;\n}\n\n.mydatahelps .bad-browser {\n\tfont-size: 1.5em;\n\tcolor: black;\n\tborder: 1px solid red;\n\tbackground-color: #ffeeee;\n\theight: 100px;\n\tposition: fixed;\n\tleft: 0;\n\tbottom: 56px;\n\twidth: 100%;\n\tz-index: 2000;\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding-top: 15px;\n}\n\n.mydatahelps .bad-browser .fa {\n\tcolor: red;\n}\n\n.mydatahelps .footer {\n\tdisplay: none;\n\tposition: fixed;\n\tleft: 0;\n\tbottom: 0;\n\twidth: 100%;\n\tbackground: #FFF;\n\tpadding: 8px 16px;\n\theight: 56px;\n\tbox-sizing: border-box;\n\ttext-align: center;\n\tbox-shadow: 0px -1px 2px 0 rgba(0, 0, 0, 0.2);\n}\n\n.mydatahelps .footer .app-download {\n\tdisplay: inline-block;\n}\n\n.mydatahelps .footer .app-download .app-download-link {\n\tfloat: left;\n\tmargin-left: 8px;\n}\n\n.mydatahelps .footer .app-download .app-download-link img {\n\theight: 40px;\n}\n\n.mydatahelps .footer .footer-text {\n\tfloat: left;\n\tline-height: 40px;\n\tfont-size: 15px;\n\tcolor: #0C509B;\n\tfont-weight: bold;\n}\n\n@media (min-width: 680px) {\n\t.mydatahelps .footer {\n\t\tdisplay: block;\n\t\tz-index: 10;\n\t}\n}\n\n.provider-account-interstitial .mydatahelps-header {\n\tdisplay: none;\n}\n\n@media (min-width: 1024px) {\n\t.mydatahelps.provider-account-interstitial {\n\t\tbox-shadow: none;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
